var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalSpecificLogo = (function(superClass) {
  utils.extend(ModalSpecificLogo, superClass);

  function ModalSpecificLogo() {
    return ModalSpecificLogo.__super__.constructor.apply(this, arguments);
  }

  ModalSpecificLogo.prototype.init = function() {
    this._addNewSpecificLogo();
    this._searchLogo();
    return ModalSpecificLogo.__super__.init.apply(this, arguments);
  };

  ModalSpecificLogo.prototype.callbackSuccess = function(data, successMsg) {
    if(data.response) {
      var $container = $('.library-items-list-selected:visible');

      if($container.length) {
        $container.find('.no-options').hide();
        $container.prepend(data.html);
      } else {
        $container = $(this.$html.data('target'));
        $container.prepend(data.html);
        appCustomerSpace.creationForm.currentStep.handleItemArrows($container);
        $target = $container.find('.with-creation-form-plugins');
        if ($target.length) {
          appCustomerSpace.LimitlessPlugins.initPlugins($target);
        }
        $('body').trigger('job_form.change', [$container.parent()]);
      }

      return ModalSpecificLogo.__super__.callbackSuccess.call(this, data);
    } else {
      this.callbackError(data);
    }
  };

  ModalSpecificLogo.prototype.callbackError = function(data) {
    this.$html.find('.logo-container').html("<p class='text-center no-margin'><em>" + data.error + "</em></p>");

    return ModalSpecificLogo.__super__.callbackError.call(this, data);
  };

  ModalSpecificLogo.prototype._searchLogo = function() {
    var self = this,
        searchTimeout = null,
        $input = this.$html.find('input[type=text]'),
        apiCredentials = $input.data('api-credentials');

    $input.on('keydown', function() {
      if(searchTimeout) clearTimeout(searchTimeout);

      if(apiCredentials) {
        searchTimeout = setTimeout(function() {
          var url = 'https://www.googleapis.com/customsearch/v1?key=' + apiCredentials.key + '&cx=' + apiCredentials.project_id + '&searchType=image&q=' + encodeURIComponent('logo '+ $input.val() + ' png') + '&start=1'

          $input.siblings('.form-control-feedback').removeClass('hidden');
          self.$html.find('button[type=submit]').addClass('disabled').prop('disabled', true);

          $.get(url, function(data) {
            if(data && data.items) {
              var link = null;

              $.each(data.items, function() {
                if(/\.(png|jpg|jpeg)/.test(this.link)) {
                  link = this.link;
                  return false;
                }
              });

              if(link) {
                var $img = $('<img/>', {
                  src: link
                });

                self.$html.find('.logo-container').html($img);

                $img.load(function() {
                  self.$html.find('input[name=specific_logo_url]').val(link);
                  self.$html.find('button[type=submit]').removeClass('disabled').prop('disabled', false);
                }).error(function() {
                  self._noLogoFound();
                });
              } else {
                self._noLogoFound();
              }
            } else {
              self._noLogoFound();
            }

            $input.siblings('.form-control-feedback').addClass('hidden');
          });
        }, 500);
      }
    });
  };

  ModalSpecificLogo.prototype._addNewSpecificLogo = function() {
    var self;
    self = this;
    this.$html.on('click', '.add-new-specific-logo', function() {
      var $formGroup;
      $formGroup = self.$html.find('.form-group');
      return $formGroup.find('.input-container:first').clone().appendTo($formGroup).find('input').val('').focus();
    });
    return this.$html.on('click', '.remove-specific-logo', function() {
      return $(this).closest('.input-container').remove();
    });
  };

  ModalSpecificLogo.prototype._noLogoFound = function() {
    this.$html.find('.logo-container').html("<p class='text-center no-margin'><em>Aucun logo trouvé</em></p>");
    this.$html.find('input[name=specific_logo_url]').val('');
    this.$html.find('.submit').prop('disabled', false);
  };

  return ModalSpecificLogo;

})(appCustomerSpace.ModalCreationFormSubmissionFunnel);
